import {firestoreAction} from "vuexfire";
import {db} from "@/plugins/db";
import * as firebase from "firebase";


export default {
    state:{
        pictionary: []
    },
    actions:{
        bindPictionary: firestoreAction(({ bindFirestoreRef }, order) => {
            return bindFirestoreRef('pictionary', db.collection('pictionary').orderBy('createdAt', order))
        }),

        createdPictionary: firestoreAction(({commit}, payload) => {
            commit('setLoading', true);
            const data: any = {
                ...payload,
                createdAt: firebase.firestore.FieldValue.serverTimestamp(),
            };
            // @ts-ignore
            return db.collection('pictionary').add(data).then(() => {
                commit('setLoading', false);
            }).catch((e) => {
                commit('setLoading', false);
                alert(e)
            })
        }),
    }
}